import { render, staticRenderFns } from "./ClickAndBuys.vue?vue&type=template&id=04db542b&scoped=true"
import script from "./ClickAndBuys.vue?vue&type=script&lang=js"
export * from "./ClickAndBuys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db542b",
  null
  
)

export default component.exports